import RequestTracker from '@/common/utils/requestTracker';
import { SCOPED_TOKEN_HEADER_NAME } from '@/common/constants/auth.constants';

export type RequestControllerItem = {
  controller: AbortController;
  requestTracker: RequestTracker;
};

export default class RequestController {
  protected requestControllers: Set<RequestControllerItem>;

  get scopedTokenHeaderName() {
    return SCOPED_TOKEN_HEADER_NAME;
  }

  constructor() {
    this.requestControllers = new Set();
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  protected handleBeforeUnload = () => {
    this.requestControllers.forEach(item => {
      item.controller.abort();
    });
    this.requestControllers.clear();
  };

  protected createRequestController(controllerItem?: AbortController): RequestControllerItem {
    const controller = controllerItem || new AbortController();
    const requestController = { controller, requestTracker: new RequestTracker(controller) };
    this.requestControllers.add(requestController);
    return requestController;
  }

  protected removeController(requestController: RequestControllerItem): void {
    if (this.requestControllers.has(requestController)) {
      this.requestControllers.delete(requestController);
    }
  }

  getController(controller: AbortController): RequestControllerItem | undefined {
    return Array.from(this.requestControllers).find(item => item.controller === controller);
  }

  abortController(requestController: RequestControllerItem): void {
    if (this.requestControllers.has(requestController)) {
      this.requestControllers.delete(requestController);
    }
  }
}
